'use client';

import React from 'react';
import type { ElementType } from 'react';
import { Header as AriaHeader } from 'react-aria-components';
import { cx } from '../../../utils/cx';
import type { PolymorphicProps } from '../../../types/polymorphic';

const MENU_HEADER_DISPLAY_NAME = 'RomaMenuHeader';
const menuHeaderClassName = 'px-2.5 py-2 text-md font-semibold text-primary';

type MenuHeaderOwnProps = {
    className?: string;
};

type MenuHeaderBaseComponentProps<T extends ElementType> = PolymorphicProps<MenuHeaderOwnProps, T>;

export type MenuHeaderBaseProps = PolymorphicProps<MenuHeaderOwnProps>;

export const MenuHeaderBase = <T extends ElementType = 'div'>(props: MenuHeaderBaseComponentProps<T>) => {
    const { as, className, ...restProps } = props;
    const Component = as ?? 'div';

    return <Component {...restProps} className={cx(MENU_HEADER_DISPLAY_NAME, menuHeaderClassName, className)} />;
};

export type MenuHeaderProps = React.ComponentPropsWithoutRef<typeof AriaHeader>;

export const MenuHeader: React.FC<MenuHeaderProps> = ({ className, ...props }) => (
    <MenuHeaderBase as={AriaHeader} {...props} className={cx(MENU_HEADER_DISPLAY_NAME, className)} />
);

MenuHeaderBase.displayName = MENU_HEADER_DISPLAY_NAME;
MenuHeader.displayName = MENU_HEADER_DISPLAY_NAME;
